<template>
  <div class="eu-display_flex eu-justify_space-between_lg">
    <div class="eu-mb_5 eu-mr_5">
      <p class="emd-text _color_subtle _type_caption eu-mb_1">
        {{ $t('charge.detail.payment-method.card.expires') }}
      </p>
      <p>{{ computedExpMonth }}/{{ computedExpYear }}</p>
    </div>
    <div class="eu-mb_5">
      <p class="emd-text _color_subtle _type_caption eu-mb_1">
        {{ $t('charge.detail.payment-method.card.installments') }}
      </p>
      <p>{{ installments || '-' }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChargesPaymentMethodPaymentCardsDetail',

  props: {
    installments: { required: true },
    expMonth: { required: true },
    expYear: { required: true }
  },

  computed: {
    computedExpMonth () {
      return this.expMonth ?? '-'
    },
    computedExpYear () {
      return this.expYear ?? '-'
    }
  }
}
</script>
